module.exports = __webpack_public_path__ + "img/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Established.69b78371.jpeg";